import { useEffect, useRef, useState } from "react";
import { Box, Button, Card, Grow, Popper, Stack, Tooltip, Typography } from "@mui/material";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { LAYOUT_MARGIN } from "Configs/home";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { useDispatch } from "react-redux";
import { useAppSelector } from "Hooks/useRedux";
import { setMapData } from "Redux/mapSlice";
import { changeShowReportRightControl } from "Redux/sideSlice";
import RightSideItems from "./RightSideItems";

export default function RightSideController() {
  const dispatch = useDispatch();
  const { zoom } = useAppSelector((state) => state.map);
  const { showReportRightControl } = useAppSelector((state) => state.side);
  const controlEl: any = useRef();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    dispatch(changeShowReportRightControl(!showReportRightControl));
    // setAnchorEl(controlEl.current);
  };

  const handleMapZoom = (index: number) => {
    const zoomLevel = 0.5;
    const newZoom = index === 0 ? zoom + zoomLevel : zoom - zoomLevel;

    dispatch(setMapData({ zoom: newZoom }));
  };

  useEffect(() => {
    setAnchorEl(controlEl.current);
  }, []);

  return (
    <Stack direction="row" spacing={1}>
      <Card component={Stack}>
        {[AddOutlinedIcon, RemoveOutlinedIcon].map((IconTag, index) => (
          <Button
            variant="white"
            sx={{
              p: 0,
              height: "50%",
              borderRadius: 0,
              minWidth: "30px",
              boxShadow: 0,
              borderBottom: index === 0 ? "1px solid #ddd" : null,
              "&:hover": { boxShadow: 0 },
            }}
            onClick={() => handleMapZoom(index)}
          >
            <IconTag sx={{ fontSize: "16px" }} />
          </Button>
        ))}
      </Card>

      <Tooltip title="سایدبار راست" placement="top">
        <Button
          sx={{ minWidth: "56px", p: 0, position: "relative", zIndex: "1" }}
          variant="white"
          size="large"
          aria-describedby="right-side-control"
          ref={controlEl}
          onClick={(e) => handleClick(e)}
        >
          <DehazeIcon />
          <Box
            sx={{
              position: "absolute",
              bottom: "8px",
              // opacity: item.type === "Menu" && index === activeOptionIndex ? "1" : "0",
              transition: "all 0.3s",
            }}
          >
            <Stack direction="row" spacing={0.3}>
              {[1, 2, 3].map((i) => (
                <Box key={`dot-${i}`} sx={{ width: "4px", height: "4px", bgcolor: "#fff", borderRadius: "50%" }} />
              ))}
            </Stack>
          </Box>
        </Button>
      </Tooltip>
      <Popper
        id="item1"
        sx={{ zIndex: "1" }}
        open={showReportRightControl}
        anchorEl={anchorEl}
        placement="top"
        transition
        modifiers={[
          {
            name: "preventOverflow",
            enabled: true,
            options: { rootBoundary: "viewport", padding: LAYOUT_MARGIN + 56 + 8 },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Box sx={{ mb: 1 }}>
              <RightSideItems />
            </Box>
          </Grow>
        )}
      </Popper>
    </Stack>
  );
}
